module.exports = __webpack_public_path__ + "static/caddy-active-c33b142fff6cac29126f57fe43b9ae28.png";